import script from "./app-layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./app-layout.vue?vue&type=script&lang=ts&setup=true"

import "./app-layout.vue?vue&type=style&index=0&id=3a5d979a&scoped=true&lang=css"
import "./app-layout.vue?vue&type=style&index=1&id=3a5d979a&lang=css"
import "./app-layout.vue?vue&type=style&index=2&id=3a5d979a&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.9.5__webpack@5.99.7/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a5d979a"]])

export default __exports__